import React from 'react'
import styled from 'styled-components'

import Logic from './logic'

import Form from 'containers/Form'
import SolarSistem from 'containers/SolarSistem'
import CentralHeating from 'containers/CentralHeating'

import Equipments from 'containers/Equipments'
import Loading from 'components/Loading'
import Error from 'components/Error'
import FixedWrapper from 'components/FixedWrapper'

import { BOOLEAN_CHOICES } from 'config'

@Logic
export default class Habitation extends Form {
  nextText = `PRÓXIMO passo`
  prevText = `Passo Anterior`

  componentDidMount() {
    // Scrols to top on component mount
    const element = document.getElementById('anchor')

    window.scroll({
      top: element.getBoundingClientRect().top,
    })
  }

  componentDidUpdate(oldProps) {
    if (oldProps.loading && !this.props.loading) {
      const element = document.getElementById('anchor')

      window.scroll({
        top: element.getBoundingClientRect().top,
      })
    }
    this.sendHeight()
    window.addEventListener('resize', this.sendHeight)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sendHeight)
  }

  sendHeight = () => {
    const height = document.body.scrollHeight
    window.parent.postMessage({ type: 'setHeight', height }, '*')
  }

  next = () => {
    window.parent.postMessage({ type: 'scrollToTop' }, '*')
    const { valid, invalid } = this.isFormValid()
    const { setInvalid, setFinished } = this.actions
    const { router } = this.props

    if (valid) {
      setFinished({ habitationFinished: true })
      router.push('/faturacao')
    } else {
      setFinished({ habitationFinished: false })
      setInvalid(invalid)
    }
  }

  prev = () => {
    const { router } = this.props
    window.parent.postMessage({ type: 'scrollToTop' }, '*')
    router.push('/')
  }

  render() {
    const { setValues } = this.actions
    const { loading, error, firstDivision, translations } = this.props

    const {
      solarSystemYears,
      offerTypes,
      centralHeatingEquipments,
      divisions,
      equipments,
      energyClasses,
    } = this.props.data

    const {
      hasSolarSystem,
      hasSolarSystemYear,
      hasCentralAirConditioning,
      centralHeatingOfferType,
      centralAirConditioningEquipment,
      centralAirConditioningEnergyClass,
    } = this.props.values

    const equipmentsProps = {
      divisions,
      equipments,
      firstDivision,
      energyClasses,
    }
    if (error) {
      return <Error />
    }

    if (loading) {
      return <Loading />
    }

    return (
      <Wrapper>
        {this.renderNavbar()}
        <FixedWrapper>
          {false && (
            <SolarSistem
              items={BOOLEAN_CHOICES}
              years={solarSystemYears}
              value={hasSolarSystem || false}
              year={hasSolarSystemYear}
              onSelectionChange={(v) => setValues(v)}
              translations={translations}
            />
          )}

          {offerTypes && centralHeatingEquipments && (
            <CentralHeating
              items={BOOLEAN_CHOICES}
              option={hasCentralAirConditioning || false}
              offerTypes={offerTypes}
              offerType={centralHeatingOfferType}
              equipments={centralHeatingEquipments}
              equipment={centralAirConditioningEquipment}
              equipmentEnergyClass={centralAirConditioningEnergyClass}
              onSelectionChange={(v) => setValues(v)}
              translations={translations}
            />
          )}

          {equipments && divisions && <Equipments {...equipmentsProps} />}
        </FixedWrapper>
        {this.renderButtons()}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  min-height: calc(100% - 60px);
  flex-direction: column;
  display: flex;
  flex: 1;
`



// WEBPACK FOOTER //
// ./src/containers/Habitation/index.js